import toast from "react-hot-toast";

/** Drop-in replacements for common antd `message` / `notification` usage */
export const message = {
  success: (content) => toast.success(String(content)),
  error: (content) => toast.error(String(content)),
  info: (content) => toast(String(content)),
  warning: (content) => toast(String(content)),
};

export const notification = {
  success: ({ message: title, description }) =>
    toast.success(description ? `${title}\n${description}` : String(title)),
  error: ({ message: title, description }) =>
    toast.error(description ? `${title}\n${description}` : String(title)),
  info: ({ message: title, description }) =>
    toast(description ? `${title}\n${description}` : String(title)),
};
